import 'bootstrap';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './App.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);